import React, { useMemo } from 'react';
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Download, Eye, Calendar } from 'lucide-react';

// (opcionais)
// import InfraLogo from "../../assets/img/infrasalogo.png";
// import OntlLogo  from "../../assets/img/logoONTL.png";

import diagnosticoPdf from "../../assets/diagnostico/diagnostivo2024.pdf";

/* === VÍDEO DE FUNDO (RODOVIAS) === */
import videoRodovias from "../../assets/img/visao_aerea_rodovias.mp4";

export default function HeroSection({ data }) {
  const [firstWords, restTitle] = useMemo(() => {
    const parts = (data?.title || "").split(" ");
    return [parts.slice(0, 2).join(" "), parts.slice(2).join(" ")];
  }, [data?.title]);

  return (
    <section className="relative h-[60dvh] min-h-[420px] w-full overflow-hidden">
      {/* CAMADA 1: VÍDEO DE FUNDO */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          className="h-full w-full object-cover object-[center_45%] pointer-events-none"
          aria-hidden="true"
          tabIndex={-1}
          onError={(e) => console.error("Falha ao carregar o vídeo:", e)}
        >
          <source src={videoRodovias} type="video/mp4" />
          Seu navegador não suporta vídeo HTML5.
        </video>
      </div>

      {/* CAMADA 2: OVERLAY AZUL ESCURO + DESFOQUE LEVE */}
      <div
        className="
          absolute inset-0 z-10
          bg-sky-900/65
          backdrop-blur-[1px]
        "
      />

      {/* CAMADA 3: CONTEÚDO */}
      <div className="relative z-20 max-w-6xl mx-auto px-4 py-10 sm:py-12 text-center">
        <Badge
          variant="outline"
          className="mb-5 px-4 py-2 bg-white/80 backdrop-blur-sm border-white/30 text-gray-900 inline-flex items-center"
        >
          <Calendar className="w-4 h-4 mr-2" />
          Publicação {data?.year}
        </Badge>

        <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-gray-100 mb-3 sm:mb-5 leading-tight">
          {firstWords}
          <span className="text-gray-200 block mt-1 sm:mt-2">
            {restTitle}
          </span>
        </h1>

        <p className="text-base sm:text-lg md:text-xl text-white/90 mb-7 sm:mb-9 max-w-3xl mx-auto leading-relaxed px-2">
          {data?.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-stretch sm:items-center">
          {/* Download */}
          <a
            href={diagnosticoPdf}
            download
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto"
          >
            <Button
              size="lg"
              className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white px-6 sm:px-8 py-4 text-base sm:text-lg group"
            >
              <Download className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform" />
              Baixar Diagnóstico Completo
            </Button>
          </a>

          {/* Visualizar Online */}
          <a
            href={diagnosticoPdf}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto"
          >
            <Button
              variant="outline"
              size="lg"
              className="w-full sm:w-auto px-6 sm:px-8 py-4 text-base sm:text-lg group border-white/40 text-white hover:bg-white/10 bg-white/5 backdrop-blur"
            >
              <Eye className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform" />
              Visualizar Online
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}